<div class="modal-header">
  <h4 class="modal-title">{{ "sphere.workspaces.move_file" | translate }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body text-left" ngbAutofocus>
  <myp-inline-loader [loading]="moving" height="200px" spinnerName="moveFileLoader"></myp-inline-loader>

  @if (!moving && !filesExistInDestination.length) {
    <div>
      <div class="text-center m-b-20">
        {{ "sphere.workspaces.select_where" | translate }}
        @if (!folderToMove) {
          {{ files.length == 1 ? files[0].filename : files.length + " files" }}
        }
        @if (folderToMove) {
          {{ folderToMove.filename }}
        }
      </div>
      <div class="move-folder-option" (click)="select('Home')" [class.selected]="selectedFolder == 'Home'">
        <fa-icon icon="home"></fa-icon>
        Home
      </div>
      <!-- The top-level folders. Initial level is 1, as home is the top. -->
      <ng-container *ngTemplateOutlet="recursiveTemplate; context: { $implicit: folders, level: 1 }"></ng-container>
    </div>
  }

  <!--
  This hidden template is used recursively for any array of folders.
  We pass along a "level" context variable to indent child folders.
  -->
  <ng-template #recursiveTemplate let-folders let-level="level">
    @for (folder of folders; track folder) {
      @if ((!folderToMove || folderToMove.id != folder.id) && !folder.synced) {
        <div class="folder-item" [style.padding-left.px]="20">
          <div class="move-folder-option" (click)="select(folder)" [class.selected]="selectedFolder?.id == folder.id">
            <fa-icon icon="folder"></fa-icon>
            {{ folder.filename }}
          </div>
          <!-- If there are children, recurse with level+1 -->
          @if (folder.children?.length) {
            <ng-container *ngTemplateOutlet="recursiveTemplate; context: { $implicit: folder.children, level: level + 1 }"></ng-container>
          }
        </div>
      }
    }
  </ng-template>

  @if (!moving && filesExistInDestination.length) {
    <div>The destination folder contains files that match the names of files you are trying to move. Please rename the following files before moving:</div>
    @for (file of filesExistInDestination; track file) {
      <div class="font-weight-bold p-10">{{ file.filename }}</div>
    }
  }
</div>
@if (!moving) {
  <div class="modal-footer">
    @if (!filesExistInDestination.length) {
      <button type="button" class="btn btn-primary" (click)="save()">{{ "sphere.workspaces.move" | translate }}</button>
    }
    <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
  </div>
}
